/**
 * The brand strings, in one place. The platform is QuantPhi (always a capital P); HopeBot is one
 * of its products. Plain data, so vite.config.ts and the build scripts can read it too.
 */

export const BRAND = {
  /** The platform. Always written with a capital P. */
  platform: 'QuantPhi',
  /** This product, one of the platform's. */
  product: 'HopeBot',
  /** The two as one name, for titles and link previews. */
  productLine: 'HopeBot by QuantPhi',
  /** The public contact address: the legal pages, KVKK applications, support. */
  contact: 'info@quantphi.app',
  /** The platform's own accounts: the landing footer and the search engines' sameAs. */
  social: {
    x: 'https://x.com/QuantPhi_app',
    telegram: 'https://t.me/Quant_Phi',
  },
} as const;
